export const CountryCodes = [
  {country: 'Afghanistan', code: '+93', iso: 'af '},
  {country: 'Albania', code: '+355', iso: 'al'},
  {country: 'Algeria', code: '+213', iso: 'dz'},
  {country: 'American Samoa', code: '+1-684', iso: 'as'},
  {country: 'Andorra', code: '+376', iso: 'ad'},
  {country: 'Angola', code: '+244', iso: 'ao'},
  {country: 'Anguilla', code: '+264', iso: 'ai'},
  {country: 'Antarctica', code: '+672', iso: 'aq'},
  {country: 'Antigua and Barbuda', code: '+1-268', iso: 'ag'},
  {country: 'Argentina', code: '+54', iso: 'ar'},
  {country: 'Armenia', code: '+374', iso: 'am'},
  {country: 'Aruba', code: '+297', iso: 'aw'},
  {country: 'Australia', code: '+61', iso: 'au'},
  {country: 'Austria', code: '+43', iso: 'at'},
  {country: 'Azerbaijan', code: '+994', iso: 'az'},
  {country: 'Bahamas', code: '+1-242', iso: 'bs'},
  {country: 'Bahrain', code: '+973', iso: 'bh'},
  {country: 'Bangladesh', code: '+880', iso: 'bd'},
  {country: 'Barbados', code: '+1-246', iso: 'bb'},
  {country: 'Belarus', code: '+375', iso: 'by'},
  {country: 'Belgium', code: '+32', iso: 'be'},
  {country: 'Belize', code: '+501', iso: 'bz'},
  {country: 'Benin', code: '+229', iso: 'bj'},
  {country: 'Bermuda', code: '+1-441', iso: 'bm'},
  {country: 'Bhutan', code: '+975', iso: 'bt'},
  {country: 'Bolivia', code: '+591', iso: 'bo'},
  {country: 'Bosnia and Herzegovina', code: '+387', iso: 'ba'},
  {country: 'Botswana', code: '+267', iso: 'bw'},
  {country: 'Brazil', code: '+55', iso: 'br'},
  {country: 'British Indian Ocean Territory', code: '+246', iso: 'io'},
  {country: 'British Virgin Islands', code: '+1-284', iso: 'vg'},
  {country: 'Brunei', code: '+673', iso: 'bn'},
  {country: 'Bulgaria', code: '+359', iso: 'bg'},
  {country: 'Burkina Faso', code: '+226', iso: 'bf'},
  {country: 'Burundi', code: '+257', iso: 'bi'},
  {country: 'Cambodia', code: '+855', iso: 'kh'},
  {country: 'Cameroon', code: '+237', iso: 'cm'},
  {country: 'Canada', code: '+1', iso: 'ca'},
  {country: 'Cape Verde', code: '+238', iso: 'cv'},
  {country: 'Cayman Islands', code: '+1-345', iso: 'ky'},
  {country: 'Central African Republic', code: '+236', iso: 'cf'},
  {country: 'Chad', code: '+235', iso: 'td'},
  {country: 'Chile', code: '+56', iso: 'cl'},
  {country: 'China', code: '+86', iso: 'cn'},
  {country: 'Christmas Island', code: '+61', iso: 'cx'},
  {country: 'Cocos Islands', code: '+61', iso: 'cc'},
  {country: 'Colombia', code: '+57', iso: 'co'},
  {country: 'Comoros', code: '+269', iso: 'km'},
  {country: 'Cook Islands', code: '+682', iso: 'ck'},
  {country: 'Costa Rica', code: '+506', iso: 'cr'},
  {country: 'Croatia', code: '+385', iso: 'hr'},
  {country: 'Cuba', code: '+53', iso: 'cu'},
  {country: 'Curacao', code: '+599', iso: 'cw'},
  {country: 'Cyprus', code: '+357', iso: 'cy'},
  {country: 'Czech Republic', code: '+420', iso: 'cz'},
  {country: 'Democratic Republic of the Congo', code: '+243', iso: 'cd'},
  {country: 'Denmark', code: '+45', iso: 'dk'},
  {country: 'Djibouti', code: '+253', iso: 'dj'},
  {country: 'Dominica', code: '+1-767', iso: 'dm'},
  {country: 'Dominican Republic', code: '+1-809', iso: 'do'},
  {country: 'Dominican Republic', code: '+1-829', iso: 'do'},
  {country: 'Dominican Republic', code: '+1-849', iso: 'do'},
  {country: 'East Timor', code: '+670', iso: 'tl'},
  {country: 'Ecuador', code: '+593', iso: 'ec'},
  {country: 'Egypt', code: '+20', iso: 'eg'},
  {country: 'El Salvador', code: '+503', iso: 'sv'},
  {country: 'Equatorial Guinea', code: '240', iso: 'gq'},
  {country: 'Eritrea', code: '+291', iso: 'er'},
  {country: 'Estonia', code: '+372', iso: 'ee'},
  {country: 'Ethiopia', code: '+251', iso: 'et'},
  {country: 'Falkland Islands', code: '+500', iso: 'fk'},
  {country: 'Faroe Islands', code: '+298', iso: 'fo'},
  {country: 'Fiji', code: '+679', iso: 'fj'},
  {country: 'Finland', code: '+358', iso: 'fi'},
  {country: 'France', code: '+33', iso: 'fr'},
  {country: 'French Polynesia', code: '+689', iso: 'pf'},
  {country: 'Gabon', code: '+241', iso: 'ga'},
  {country: 'Gambia', code: '+220', iso: 'gm'},
  {country: 'Georgia', code: '+995', iso: 'ge'},
  {country: 'Germany', code: '+49', iso: 'de'},
  {country: 'Ghana', code: '+233', iso: 'gh'},
  {country: 'Gibraltar', code: '+350', iso: 'gi'},
  {country: 'Greece', code: '+30', iso: 'gr'},
  {country: 'Greenland', code: '+299', iso: 'gl'},
  {country: 'Grenada', code: '+1-473', iso: 'gd'},
  {country: 'Guam', code: '+1-671', iso: 'gu'},
  {country: 'Guatemala', code: '+502', iso: 'gt'},
  {country: 'Guernsey', code: '+44-1481', iso: 'gg'},
  {country: 'Guinea', code: '+224', iso: 'gn'},
  {country: 'Guinea-Bissau', code: '+245', iso: 'gw'},
  {country: 'Guyana', code: '+592', iso: 'gy'},
  {country: 'Haiti', code: '+509', iso: 'ht'},
  {country: 'Honduras', code: '+504', iso: 'hn'},
  {country: 'Hong Kong', code: '+852', iso: 'hk'},
  {country: 'Hungary', code: '+36', iso: 'hu'},
  {country: 'Iceland', code: '+354', iso: 'is'},
  {country: 'India', code: '+91', iso: 'in'},
  {country: 'Indonesia	', code: '+62', iso: 'id'},
  {country: 'Iran', code: '+98', iso: 'ir'},
  {country: 'Iraq', code: '+964', iso: 'iq'},
  {country: 'Ireland', code: '+353', iso: 'ie'},
  {country: 'Isle of Man', code: '+44-1624', iso: 'im'},
  {country: 'Israel', code: '+972', iso: 'il'},
  {country: 'Italy', code: '+39', iso: 'it'},
  {country: 'Ivory Coast', code: '+225', iso: 'ci'},
  {country: 'Jamaica', code: '+1-876', iso: 'jm'},
  {country: 'Japan', code: '+81', iso: 'jp'},
  {country: 'Jersey', code: '+44-1534', iso: 'je'},
  {country: 'Jordan', code: '+962', iso: 'jo'},
  {country: 'Kazakhstan', code: '+7', iso: 'kz'},
  {country: 'Kenya', code: '+254', iso: 'ke'},
  {country: 'Kiribati', code: '+686', iso: 'ki'},
  {country: 'Kosovo', code: '+383', iso: 'xk'},
  {country: 'Kuwait', code: '+965', iso: 'kw'},
  {country: 'Kyrgyzstan', code: '+996', iso: 'kg'},
  {country: 'Laos', code: '+856', iso: 'la'},
  {country: 'Latvia', code: '+371', iso: 'lv'},
  {country: 'Lebanon', code: '+961', iso: 'lb'},
  {country: 'Lesotho', code: '+266', iso: 'ls'},
  {country: 'Liberia', code: '+231', iso: 'lr'},
  {country: 'Libya', code: '+218', iso: 'ly'},
  {country: 'Liechtenstein', code: '+423', iso: 'li'},
  {country: 'Lithuania', code: '+370', iso: 'lt'},
  {country: 'Luxembourg', code: '+352', iso: 'lu'},
  {country: 'Macau', code: '+853', iso: 'mo'},
  {country: 'Macedonia', code: '+389', iso: 'mk'},
  {country: 'Madagascar', code: '+261', iso: 'mg'},
  {country: 'Malawi', code: '+265', iso: 'mw'},
  {country: 'Malaysia', code: '+60', iso: 'my'},
  {country: 'Maldives', code: '+960', iso: 'mv'},
  {country: 'Mali', code: '+223', iso: 'ml'},
  {country: 'Malta', code: '+356', iso: 'mt'},
  {country: 'Marshall Islands', code: '+692', iso: 'mh'},
  {country: 'Mauritania', code: '+222', iso: 'mr'},
  {country: 'Mauritius', code: '+230', iso: 'mu'},
  {country: 'Mayotte', code: '+262', iso: 'yt'},
  {country: 'Mexico', code: '+52', iso: 'mx'},
  {country: 'Micronesia', code: '+691', iso: 'fm'},
  {country: 'Moldova', code: '+373', iso: 'md'},
  {country: 'Monaco', code: '+377', iso: 'mc'},
  {country: 'Mongolia', code: '+976', iso: 'mn'},
  {country: 'Montenegro', code: '+382', iso: 'me'},
  {country: 'Montserrat', code: '+1-664', iso: 'ms'},
  {country: 'Morocco', code: '+212', iso: 'ma'},
  {country: 'Mozambique', code: '+258', iso: 'mz'},
  {country: 'Myanmar', code: '+95', iso: 'mm'},
  {country: 'Namibia', code: '+264', iso: 'na'},
  {country: 'Nauru', code: '+674', iso: 'nr'},
  {country: 'Nepal', code: '+977', iso: 'np'},
  {country: 'Netherlands', code: '+31', iso: 'nl'},
  // {country: 'Netherlands Antilles', code: '+599', iso: 'an'},
  {country: 'New Caledonia', code: '+687', iso: 'nc'},
  {country: 'New Zealand', code: '+64', iso: 'nz'},
  {country: 'Nicaragua', code: '+505', iso: 'ni'},
  {country: 'Niger', code: '+227', iso: 'ne'},
  {country: 'Nigeria', code: '+234', iso: 'ng'},
  {country: 'Niue', code: '+683', iso: 'nu'},
  {country: 'North Korea', code: '+850', iso: 'kp'},
  {country: 'Northern Mariana Islands', code: '+1-670', iso: 'mp'},
  {country: 'Norway', code: '+47', iso: 'no'},
  {country: 'Oman', code: '+968', iso: 'om'},
  {country: 'Pakistan', code: '+92', iso: 'pk'},
  {country: 'Palau', code: '+680', iso: 'pw'},
  {country: 'Palestine', code: '+970', iso: 'ps'},
  {country: 'Panama', code: '+507', iso: 'pa'},
  {country: 'Papua New Guinea', code: '+675', iso: 'pg'},
  {country: 'Paraguay', code: '+595', iso: 'py'},
  {country: 'Peru', code: '+51', iso: 'pe'},
  {country: 'Philippines', code: '+63', iso: 'ph'},
  {country: 'Pitcairn', code: '+64', iso: 'pn'},
  {country: 'Poland', code: '+48', iso: 'pl'},
  {country: 'Portugal', code: '+351', iso: 'pt'},
  {country: 'Puerto Rico', code: '+1-787', iso: 'pr'},
  {country: 'Puerto Rico', code: '+1-939', iso: 'pr'},
  {country: 'Qatar', code: '+974', iso: 'qa'},
  {country: 'Republic of the Congo', code: '+242', iso: 'cg'},
  {country: 'Reunion', code: '+262', iso: 're'},
  {country: 'Romania', code: '+40', iso: 'ro'},
  {country: 'Russia', code: '+7', iso: 'ru'},
  {country: 'Rwanda', code: '+250', iso: 'rw'},
  {country: 'Saint Barthelemy', code: '+590', iso: 'bl'},
  {country: 'Saint Helena', code: '+290', iso: 'sh'},
  {country: 'Saint Kitts and Nevis', code: '+1-869', iso: 'kn'},
  {country: 'Saint Lucia', code: '+1-758', iso: 'lc'},
  {country: 'Saint Martin', code: '+590', iso: 'mf'},
  {country: 'Saint Pierre and Miquelon', code: '+508', iso: 'pm'},
  {country: 'Saint Vincent and the Grenadines', code: '+1-784', iso: 'vc'},
  {country: 'Samoa', code: '+685', iso: 'ws'},
  {country: 'San Marino', code: '+378', iso: 'sm'},
  {country: 'Sao Tome and Principe', code: '+239', iso: 'st'},
  {country: 'Saudi Arabia', code: '+966', iso: 'sa'},
  {country: 'Senegal', code: '+221', iso: 'sn'},
  {country: 'Serbia', code: '+381', iso: 'rs'},
  {country: 'Seychelles', code: '+248', iso: 'sc'},
  {country: 'Sierra Leone', code: '+232', iso: 'sl'},
  {country: 'Singapore', code: '+65', iso: 'sg'},
  {country: 'Sint Maarten', code: '+1-721', iso: 'sx'},
  {country: 'Slovakia', code: '+421', iso: 'sk'},
  {country: 'Slovenia', code: '+386', iso: 'si'},
  {country: 'Solomon Islands', code: '+677', iso: 'sb'},
  {country: 'Somalia', code: '+252', iso: 'so'},
  {country: 'South Africa', code: '+27', iso: 'za'},
  {country: 'South Korea', code: '+82', iso: 'kr'},
  {country: 'South Sudan', code: '+211', iso: 'ss'},
  {country: 'Spain', code: '+34', iso: 'es'},
  {country: 'Sri Lanka', code: '+94', iso: 'lk'},
  {country: 'Sudan', code: '+249', iso: 'sd'},
  {country: 'Suriname', code: '+597', iso: 'sr'},
  {country: 'Svalbard and Jan Mayen', code: '+47', iso: 'sj'},
  {country: 'Swaziland', code: '+268', iso: 'sz'},
  {country: 'Sweden', code: '+46', iso: 'se'},
  {country: 'Switzerland', code: '+41', iso: 'ch'},
  {country: 'Syria', code: '+963', iso: 'sy'},
  {country: 'Taiwan', code: '+886', iso: 'tw'},
  {country: 'Tajikistan', code: '+992', iso: 'tj'},
  {country: 'Tanzania', code: '+255', iso: 'tz'},
  {country: 'Thailand', code: '+66', iso: 'th'},
  {country: 'Togo', code: '+228', iso: 'tg'},
  {country: 'Tokelau', code: '+690', iso: 'tk'},
  {country: 'Tonga', code: '+676', iso: 'to'},
  {country: 'Trinidad and Tobago', code: '+1-868', iso: 'tt'},
  {country: 'Tunisia', code: '+216', iso: 'tn'},
  {country: 'Turkey', code: '+90', iso: 'tr '},
  {country: 'Turkmenistan', code: '+993', iso: 'tm'},
  {country: 'Turks and Caicos Islands', code: '+1-649', iso: 'tc'},
  {country: 'Tuvalu', code: '+688', iso: 'tv'},
  {country: 'U.S. Virgin Islands', code: '+1-340', iso: 'vi'},
  {country: 'Uganda', code: '+256', iso: 'ug'},
  {country: 'Ukraine', code: '+380', iso: 'ua'},
  {country: 'United Arab Emirates', code: '+971', iso: 'ae'},
  {country: 'United Kingdom', code: '+44', iso: 'gb'},
  {country: 'United States', code: '+1', iso: 'us'},
  {country: 'Uruguay', code: '+598', iso: 'uy'},
  {country: 'Uzbekistan', code: '+998', iso: 'uz'},
  {country: 'Vanuatu', code: '+678', iso: 'vu'},
  {country: 'Vatican', code: '+379', iso: 'va'},
  {country: 'Venezuela	', code: '+58', iso: 've'},
  {country: 'Vietnam', code: '+84', iso: 'vn'},
  {country: 'Wallis and Futuna', code: '+681', iso: 'wf'},
  {country: 'Western Sahara', code: '+212', iso: 'eh'},
  {country: 'Yemen', code: '+967', iso: 'ye'},
  {country: 'Zambia', code: '+260', iso: 'zm'},
  {country: 'Zimbabwe', code: '+263', iso: 'zw'}
];

export const Iso2Conversion = {
  AFG: 'AF',
  ALA: 'AX',
  ALB: 'AL',
  DZA: 'DZ',
  ASM: 'AS',
  AND: 'AD',
  AGO: 'AO',
  AIA: 'AI',
  ATA: 'AQ',
  ATG: 'AG',
  ARG: 'AR',
  ARM: 'AM',
  ABW: 'AW',
  AUS: 'AU',
  AUT: 'AT',
  AZE: 'AZ',
  BHS: 'BS',
  BHR: 'BH',
  BGD: 'BD',
  BRB: 'BB',
  BLR: 'BY',
  BEL: 'BE',
  BLZ: 'BZ',
  BEN: 'BJ',
  BMU: 'BM',
  BTN: 'BT',
  BOL: 'BO',
  BES: 'BQ',
  BIH: 'BA',
  BWA: 'BW',
  BVT: 'BV',
  BRA: 'BR',
  IOT: 'IO',
  BRN: 'BN',
  BGR: 'BG',
  BFA: 'BF',
  BDI: 'BI',
  CPV: 'CV',
  KHM: 'KH',
  CMR: 'CM',
  CAN: 'CA',
  CYM: 'KY',
  CAF: 'CF',
  TCD: 'TD',
  CHL: 'CL',
  CHN: 'CN',
  CXR: 'CX',
  CCK: 'CC',
  COL: 'CO',
  COM: 'KM',
  COG: 'CG',
  COD: 'CD',
  COK: 'CK',
  CRI: 'CR',
  CIV: 'CI',
  HRV: 'HR',
  CUB: 'CU',
  CUW: 'CW',
  CYP: 'CY',
  CZE: 'CZ',
  DNK: 'DK',
  DJI: 'DJ',
  DMA: 'DM',
  DOM: 'DO',
  ECU: 'EC',
  EGY: 'EG',
  SLV: 'SV',
  GNQ: 'GQ',
  ERI: 'ER',
  EST: 'EE',
  ETH: 'ET',
  FLK: 'FK',
  FRO: 'FO',
  FJI: 'FJ',
  FIN: 'FI',
  FRA: 'FR',
  GUF: 'GF',
  PYF: 'PF',
  ATF: 'TF',
  GAB: 'GA',
  GMB: 'GM',
  GEO: 'GE',
  DEU: 'DE',
  GHA: 'GH',
  GIB: 'GI',
  GRC: 'GR',
  GRL: 'GL',
  GRD: 'GD',
  GLP: 'GP',
  GUM: 'GU',
  GTM: 'GT',
  GGY: 'GG',
  GIN: 'GN',
  GNB: 'GW',
  GUY: 'GY',
  HTI: 'HT',
  HMD: 'HM',
  VAT: 'VA',
  HND: 'HN',
  HKG: 'HK',
  HUN: 'HU',
  ISL: 'IS',
  IND: 'IN',
  IDN: 'ID',
  IRN: 'IR',
  IRQ: 'IQ',
  IRL: 'IE',
  IMN: 'IM',
  ISR: 'IL',
  ITA: 'IT',
  JAM: 'JM',
  JPN: 'JP',
  JEY: 'JE',
  JOR: 'JO',
  KAZ: 'KZ',
  KEN: 'KE',
  KIR: 'KI',
  PRK: 'KP',
  KOR: 'KR',
  KWT: 'KW',
  KGZ: 'KG',
  LAO: 'LA',
  LVA: 'LV',
  LBN: 'LB',
  LSO: 'LS',
  LBR: 'LR',
  LBY: 'LY',
  LIE: 'LI',
  LTU: 'LT',
  LUX: 'LU',
  MAC: 'MO',
  MKD: 'MK',
  MDG: 'MG',
  MWI: 'MW',
  MYS: 'MY',
  MDV: 'MV',
  MLI: 'ML',
  MLT: 'MT',
  MHL: 'MH',
  MTQ: 'MQ',
  MRT: 'MR',
  MUS: 'MU',
  MYT: 'YT',
  MEX: 'MX',
  FSM: 'FM',
  MDA: 'MD',
  MCO: 'MC',
  MNG: 'MN',
  MNE: 'ME',
  MSR: 'MS',
  MAR: 'MA',
  MOZ: 'MZ',
  MMR: 'MM',
  NAM: 'NA',
  NRU: 'NR',
  NPL: 'NP',
  NLD: 'NL',
  NCL: 'NC',
  NZL: 'NZ',
  NIC: 'NI',
  NER: 'NE',
  NGA: 'NG',
  NIU: 'NU',
  NFK: 'NF',
  MNP: 'MP',
  NOR: 'NO',
  OMN: 'OM',
  PAK: 'PK',
  PLW: 'PW',
  PSE: 'PS',
  PAN: 'PA',
  PNG: 'PG',
  PRY: 'PY',
  PER: 'PE',
  PHL: 'PH',
  PCN: 'PN',
  POL: 'PL',
  PRT: 'PT',
  PRI: 'PR',
  QAT: 'QA',
  REU: 'RE',
  ROU: 'RO',
  RUS: 'RU',
  RWA: 'RW',
  BLM: 'BL',
  SHN: 'SH',
  KNA: 'KN',
  LCA: 'LC',
  MAF: 'MF',
  SPM: 'PM',
  VCT: 'VC',
  WSM: 'WS',
  SMR: 'SM',
  STP: 'ST',
  SAU: 'SA',
  SEN: 'SN',
  SRB: 'RS',
  SYC: 'SC',
  SLE: 'SL',
  SGP: 'SG',
  SXM: 'SX',
  SVK: 'SK',
  SVN: 'SI',
  SLB: 'SB',
  SOM: 'SO',
  ZAF: 'ZA',
  SGS: 'GS',
  SSD: 'SS',
  ESP: 'ES',
  LKA: 'LK',
  SDN: 'SD',
  SUR: 'SR',
  SJM: 'SJ',
  SWZ: 'SZ',
  SWE: 'SE',
  CHE: 'CH',
  SYR: 'SY',
  TWN: 'TW',
  TJK: 'TJ',
  TZA: 'TZ',
  THA: 'TH',
  TLS: 'TL',
  TGO: 'TG',
  TKL: 'TK',
  TON: 'TO',
  TTO: 'TT',
  TUN: 'TN',
  TUR: 'TR',
  TKM: 'TM',
  TCA: 'TC',
  TUV: 'TV',
  UGA: 'UG',
  UKR: 'UA',
  ARE: 'AE',
  GBR: 'GB',
  USA: 'US',
  UMI: 'UM',
  URY: 'UY',
  UZB: 'UZ',
  VUT: 'VU',
  VEN: 'VE',
  VNM: 'VN',
  VGB: 'VG',
  VIR: 'VI',
  WLF: 'WF',
  ESH: 'EH',
  YEM: 'YE',
  ZMB: 'ZM',
  ZWE: 'ZW'
};

export const IsoCountries = {
  Afghanistan: 'AF',
  'Aland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua And Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bosnia And Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  Congo: 'CG',
  'Congo, Democratic Republic': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  'Cote D\'Ivoire': 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island & Mcdonald Islands': 'HM',
  'Holy See (Vatican City State)': 'VA',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  'Iran, Islamic Republic Of': 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle Of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  'Republic of Korea': 'KR',
  'Korea (Republic of)': 'KR',
  'South Korea': 'KR',
  'Democratic People\'s Republic of Korea': 'KP',
  'North Korea': 'KP',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  'Lao People\'s Democratic Republic': 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  'Libyan Arab Jamahiriya': 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macedonia: 'MK',
  'North Macedonia': 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  'Micronesia, Federated States Of': 'FM',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'Netherlands Antilles': 'AN',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestinian Territory, Occupied': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  Reunion: 'RE',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  'Saint Barthelemy': 'BL',
  'Saint Helena': 'SH',
  'Saint Kitts And Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'MF',
  'Saint Pierre And Miquelon': 'PM',
  'Saint Vincent And Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome And Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia And Sandwich Isl.': 'GS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard And Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  'Syrian Arab Republic': 'SY',
  Taiwan: 'TW',
  'Taiwan, Province of China[a]': 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  'Timor-Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad And Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks And Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'Great Britain': 'GB',
  'United States': 'US',
  'United States of America': 'US',
  'United States Outlying Islands': 'UM',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Venezuela: 'VE',
  'Venezuela (Bolivarian Republic of)': 'VE',
  Vietnam: 'VN',
  'Viet Nam': 'VN',
  'Virgin Islands, British': 'VG',
  'Virgin Islands, U.S.': 'VI',
  'Wallis And Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW'
} as unknown as IsoCountries[];

interface IsoCountries {
  [key: string]: string;
  [Iso2Code: string]: string;
}
